"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LegacyContext = exports.AutocompleteContext = void 0;
exports.useAutocompleteState = useAutocompleteState;
var _react = require("react");
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */

var LegacyContext = exports.LegacyContext = /*#__PURE__*/(0, _react.createContext)({});
LegacyContext.displayName = 'ClayAutocompleteLegacyContext';
var AutocompleteContext = exports.AutocompleteContext = /*#__PURE__*/(0, _react.createContext)({});
function useAutocompleteState() {
  return (0, _react.useContext)(AutocompleteContext);
}